import {
  _
} from 'vue-underscore'

const state = {
  af_decision: [{
      id: -1,
      name: "Reject",
      human_name: "Отклонено",
      style: "s-rejected"
    },
    {
      id: 0,
      name: "Accept",
      human_name: "Принято",
      style: "s-charged"
    },
    {
      id: 1,
      name: "Forward",
      human_name: "Переадресовано",
      style: "s-none"
    },
    {
      id: 100,
      name: "N/A",
      human_name: "Без решения",
      style: "s-none"
    },
  ]
}

const getters = {
  decisionList(state) {
    return state.af_decision
  },
  decisionName: state => id => {
    if (state.af_decision && state.af_decision.length > 0 && id != null) {
      return state.af_decision.find(el => el.id === id)['human_name']
    } else {
      return ""
    }
  },
  decisionStyle: state => id => {
    if (state.af_decision && state.af_decision.length > 0 && id != null) {
      return state.af_decision.find(el => el.id === id)['style']
    } else {
      return 's-none'
    }
  }
}

export default {
  state,
  getters
}
